"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.wrapPageElement = void 0;
var _react = _interopRequireDefault(require("react"));
var _gatsby = require("gatsby");
var _browserLang = _interopRequireDefault(require("browser-lang"));
var _LocaleProvider = require("./LocaleProvider");
var _options = require("./options");
var isRedirect = false;
var wrapPageElement = exports.wrapPageElement = function wrapPageElement(_ref) {
  var element = _ref.element,
    props = _ref.props;
  if (typeof window !== 'undefined') {
    var detectedLanguage = (0, _browserLang.default)({
      languages: (0, _options.getLanguages)(),
      fallback: _options.defaultLang
    });
    if (!isRedirect) {
      if (!props || !props.pageContext || !props.pageContext.locale) {
        if (window.location.href.indexOf('404') !== -1) {
          (0, _gatsby.navigate)((_options.urlPrefixPath ? "/" + _options.urlPrefixPath : '') + ("/" + detectedLanguage));
        }
      }
    }
  }
  return /*#__PURE__*/_react.default.createElement(_LocaleProvider.LocaleProvider, {
    pageContext: props.pageContext
  }, element);
};